module.exports = __webpack_public_path__ + "media/images/country_flags/rs-987680f95ae120a1b8c0f791c9619119.png";